import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { submitPan, getDgLocker } from "./redux/action";
import { setAddressForcefullyRedux, getStageScreen } from "../../../../redux";
import Title from "../../components/Title";
import TextInput from "../../components/TextInput";
import Button from "../../components/Button";
import { Modal } from "react-bootstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import InputMask from "react-input-mask";
import "./style.css";
import InputTitle from "designs/v1/components/InputTitle";

const PanAddress = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isCalled, setIsCalled] = useState(false);
  const [panInfo, setPanInfo] = useState(false);
  const [showPanInfoModal, setShowPanInfoModal2] = useState(false);
  const [showDgLockerModal, setShowDgLockerModal] = useState(false);
  const { loading } = useSelector((state) => state.common);
  const { digilocker, kycStatus, pageName, pageFlow } = useSelector(
    (state) => state.navigation
  );



  const { inputLabelColor, inputIconColor, inputError, themeTemplate } =
    useSelector((state) => state.theme);

  const [kraStatus, setKraStatus] = useState(false);

  const minDate = new Date("01/01/1920");
  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() - 18);

  useEffect(() => {
    let dlocker = window.localStorage.getItem("dlocker");
    if (dlocker) {
      window.localStorage.removeItem("dlocker");
      window.location.reload();
    }
  }, [history]);

  const pushAddressForcefully = () => {
    let index = 0;
    for (let i in pageFlow) {
      if (pageFlow[i] == "Address") {
        index = i;
      }
    }
    dispatch(setAddressForcefullyRedux(index, false));
  };
  useEffect(() => {
    for (let i in kycStatus) {
      let key = Object.keys(kycStatus[i]);
      if (key == "PAN") {
        let isPanVerified = kycStatus[i]["PAN"].pan_number_verified;
        let status = kycStatus[i]["PAN"].status;
        if (isPanVerified == 1 && status != 1) {
          pushAddressForcefully();
        }
      }
    }
  }, [kycStatus, showDgLockerModal]);

  const fields = {
    pan: "",
    dob: "",
    name_as_per_pan: ""
  };
  const [values, setValues] = useState(fields);
  const [errors, setErrors] = useState(fields);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    handleValidate(values);
  }, [values]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: ["pan", "name_as_per_pan"].includes(name) ? value?.toUpperCase() : value,
    });
  };

  const handleValidate = (values) => {
    var regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
    var years = moment().diff(values.dob, "years");
    let errors = {};
    let isValid = true;
    if (!values.name_as_per_pan) {
      isValid = false;
      errors["name_as_per_pan"] = "Please enter name as per PAN";
    }
    if (!regex.test(values.pan)) {
      isValid = false;
      errors["pan"] = "Invalid PAN Number";
    }
    if (!values["pan"]) {
      isValid = false;
      errors["pan"] = "Please enter PAN";
    }
    if (years < 18) {
      isValid = false;
      errors["dob"] = "Age should be 18 or more.";
    }
    if (!values["dob"]) {
      isValid = false;
      errors["dob"] = "Please enter date of birth.";
    }
    setErrors(errors);
    return isValid;
  };

  const sumbitPanDetails = (event) => {
    event.preventDefault();
    setSubmitted(true);
    if (handleValidate(values)) {
      const payload = {
        ...values,
        dob: moment(values.dob).format("DD-MM-YYYY"),
      };
      dispatch(
        submitPan(
          payload,
          digilocker,
          setPanInfo,
          setShowPanInfoModal,
          setKraStatus,
          history
        )
      );
    }
  };

  const handleSubmitModal = (value) => {
    setShowDgLockerModal(false);
    if (value === "Yes") {
      dispatch(getDgLocker());
    } else {
      history.push("/address");
      dispatch(getStageScreen());
    }
  };

  const onKeyPress = (evt) => {
    let charCode = evt.which ? evt.which : evt.keyCode;
    if (
      charCode > 31 &&
      (charCode < 65 || charCode > 90) &&
      (charCode < 97 || charCode > 122) &&
      (charCode < 48 || charCode > 57)
    ) {
      evt.preventDefault();
    }
  };
  const setShowPanInfoModal = (value) => {
    if (value) {
      if (kraStatus) {
        setShowPanInfoModal2(false);
        setKraStatus(false);
        history.push("/address");
        dispatch(getStageScreen());
      } else {
        setShowPanInfoModal2(false);
        setShowDgLockerModal(true);
      }
    }
  }

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12 mb-4">
          <Title title="PAN DETAILS" />
        </div>
        <form onSubmit={sumbitPanDetails}>
          <div className="text-danger font-weight-bold">Please enter the Name and Date of Birth as per the Income Tax database for validation.</div>
          <div className="col-md-6">

            <div className="form-group mt-2">
              <TextInput
                label="PAN Number"
                name="pan"
                placeholder="PAN Number"
                value={values.pan}
                onChange={handleChange}
                onKeyPress={onKeyPress}
                error={submitted && !!errors.pan && errors.pan}
                maxLength={10}
                marginTop={2}
              />
            </div>
            <div className="form-group mt-2">
              <TextInput
                label="Name as per PAN"
                name="name_as_per_pan"
                placeholder="Name as per PAN"
                value={values.name_as_per_pan}
                onChange={handleChange}
                error={submitted && !!errors.name_as_per_pan && errors.name_as_per_pan}
                maxLength={100}
                marginTop={2}
              />
            </div>
            <div className="form-group mt-2">
              <InputTitle
                title={'Date of Birth'}
              />
              {/* <TextInput
                label="Date of Birth"
                name="dob"
                type="date"
                value={values.dob}
                onChange={handleChange}
                error={submitted && !!errors.dob && errors.dob}
                max="2005-12-31"
                min="1920-01-01"
              /> */}
              <DatePicker
                placeholderText="dd/mm/yyyy"
                dateFormat="dd/MM/yyyy"
                selected={values.dob}
                onChange={(date) =>
                  setValues({
                    ...values,
                    dob: date,
                  })
                }
                customInput={
                  <InputMask
                    style={{ width: "100%" }}
                    mask="99/99/9999"
                  />
                }
                maxDate={maxDate}
                minDate={minDate}
                className={`${themeTemplate == "103" ||
                  themeTemplate == "106" ||
                  themeTemplate == "105"
                  ? "custom-form-control2"
                  : themeTemplate == "109"
                    ? "custom-form-control3"
                    : "custom-form-control"
                  }`}
                style={{ textIndent: 20 }}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                isClearable
              />
              {submitted && errors.dob && (
                <div style={{ color: inputError, fontSize: 12 }}>
                  {errors.dob}
                </div>
              )}
            </div>
          </div>
          <div className="col-md-12 mt-3">
            <Button
              title="Submit"
              disabled={loading}
            />
          </div>
        </form>
      </div>
      <Modal show={showPanInfoModal}>
        <Modal.Header>
          <Modal.Title>Name as per PAN</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6>
            Do you want to proceed with this{" "}
            <strong>{panInfo?.full_name}</strong>
          </h6>
        </Modal.Body>
        <Modal.Footer>
          <Button
            title="Proceed"
            handleClick={() => {
              if (kraStatus) {
                setShowPanInfoModal(false);
                setKraStatus(false);
                history.push("/address");
                dispatch(getStageScreen());
              } else {
                setShowPanInfoModal(false);
                setShowDgLockerModal(true);
              }
            }}
          />
          <Button
            title="Cancel"
            handleClick={() => setShowPanInfoModal(false)}
          />
        </Modal.Footer>
      </Modal>
      <Modal show={showDgLockerModal}>
        <Modal.Header>
          <Modal.Title>Continue with DigiLocker</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6>Do you want to proceed with digilocker?</h6>
        </Modal.Body>
        <Modal.Footer>
          <Button
            title="No, I upload manually"
            handleClick={() => handleSubmitModal("No")}
          />
          <Button
            title="Yes"
            handleClick={() => handleSubmitModal("Yes")}
          />
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default PanAddress;
